import React from 'react';
import { RoleType } from '@/constants';
import { TAB_TOP_ID } from '@/pages/Homepage/constants';
import { ContentMenu } from '@/pages/Homepage/components';
import { useMenu, UseMenuOptions } from './index.ViewHook';

interface MenuProps extends UseMenuOptions {
  type: RoleType;
}

export const Menu = React.memo(({ type }: MenuProps) => {
  const { contentId, defaultOpenKeys, contents, handleClick } = useMenu({
    type,
  });

  return (
    <ContentMenu
      defaultOpenKeys={defaultOpenKeys}
      defaultSelectedKeys={[contentId]}
      contents={contents}
      onClickMenuItem={handleClick}
      anchor={TAB_TOP_ID}
      menuPage="seller_university_homepage"
      menuModule="seller_university_homepage_feature_guide"
    />
  );
});
